import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';

const AiReportCount = ({ data = {} }) => {
  const stats = [
    {
      label: 'Active Calls',
      value: data.activeCalls ?? 0,
      icon: <Icon.Activity size={18} />,
      color: '#2cabe3'
    },
    {
      label: 'Completed',
      value: data.completedToday ?? 0,
      icon: <Icon.CheckCircle size={18} />,
      color: '#2cd07e'
    },
    // {
    //   label: 'Avg MOS',
    //   value: data.avgMOS ?? '0.0',
    //   icon: <Icon.Star size={18} />,
    //   color: '#ffb22b'
    // },
    // {
    //   label: 'SLA %',
    //   value: `${data.slaPercent ?? 0}%`,
    //   icon: <Icon.Percent size={18} />,
    //   color: '#775dd0'
    // },
    // {
    //   label: 'Fallback Rate',
    //   value: `${data.apiFallbackRate ?? 0}%`,
    //   icon: <Icon.AlertTriangle size={18} />,
    //   color: '#ff4560'
    // },
    {
      label: 'AI Agents',
      value: data.aiAgentsAvailable ?? 0,
      icon: <Icon.Cpu size={18} />,
      color: '#6376ff'
    }
    // {
    //   label: 'Human Agents',
    //   value: data.humanAgentsAvailable ?? 0,
    //   icon: <Icon.Users size={18} />,
    //   color: '#800080'
    // }
    // { label: 'Queue Depth', value: data.queueDepth ?? 0, icon: <Icon.List size={18} />, color: '#545b62' }
  ];

  return (
    <div className="report-container">
      <div className="d-flex justify-content-around align-items-center">
        {stats.map((stat, index) => (
          <div key={index} className="px-1" style={{ width: `${100 / stats.length}%` }}>
            <Card
              className="report-card px-2"
              style={{ borderBottom: `2px solid ${stat.color}`, background: `${stat.color}33` }}>
              <div className="card-icon" style={{ backgroundColor: stat.color }}>
                <div className="icon mr-2 fs-5" style={{ color: 'white' }}>
                  {stat.icon}
                </div>
              </div>
              <div className="d-flex flex-column ps-2">
                <span className="fs-6">{stat.label}</span>
                <span className="fs-4">{stat.value}</span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

AiReportCount.propTypes = {
  data: PropTypes.object
};

export default AiReportCount;
